import { SearchService } from './SearchService';

export class SearchDisplay<TFacets extends string, ISearchResult> {
	protected _element: JQuery<HTMLElement>;
	protected _searchService: SearchService<TFacets, ISearchResult>;

	/**
	 *
	 * @param element
	 * @param searchService
	 */
	constructor(
		element: JQuery<HTMLElement>,
		searchService: SearchService<TFacets, ISearchResult>,
	) {
		this._element = element;
		this._searchService = searchService;

		searchService.addResultsListener(() => this.render());
	}

	protected render() {
		this._element.attr(
			'data-search-display',
			this._searchService.isSearched ? 'active' : '',
		);
	}
}



// WEBPACK FOOTER //
// ./scripts/algolia/SearchDisplay.ts